import MentorApplicationList from './MentorApplicationList/MentorApplicationList'
import MentorApplicationEdit from './MentorApplicationEdit/MentorApplicationEdit'
import MentorApplicationIcon from '@material-ui/icons/SupervisorAccount'

export default {
  list: MentorApplicationList,
  edit: MentorApplicationEdit,
  icon: MentorApplicationIcon,
  options: { label: 'Mentor Application' }
}